import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=765be841&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=765be841&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765be841",
  null
  
)

export default component.exports